// extracted by mini-css-extract-plugin
module.exports = {"content":"ContentPage_content__FUPmn","centered":"ContentPage_centered__WyiBF"};